<template>
  <input :value="value"
         :name="name"
         :id="id"
         :class="{'error': errors.length > 0}"
         :readOnly="readOnly"
         type="text"
         maxlength="34"
         class="accountnumber"
         @input="(e) => { $emit('input', normalizeIban(e.target.value)) }"
         @blur="(e) => { $emit('blur', normalizeIban(e.target.value)) }">
</template>
<script>

export default {
  name: 'IbanField',
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    normalizeIban (iban) {
      return iban.replace(/[\W_]+/g, '').toUpperCase()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IbanField.vue